const PageTurner: React.FC<
  JSX.IntrinsicElements['button']
> = ({ children, ...props }) => (
  <button type="submit" {...props}>
    <span className="select-none text-3xl text-black">
      {children}
    </span>
  </button>
)

export default PageTurner
